import * as charts from "../../charts/";
import { ChartType } from "../../entities/reportEntity";

export default {
  id: 46,
  label: "申请人法律状态分析",
  chart: charts.lineAndBar2D,
  definition: {
    rowDims: [
      {
        name: "applicantNewName",
        label: "申请人",
        table: "patent_applicant",
        limit: 10,
        needTotal: true,
      },
    ],
    colDims: [{ name: "legalStatus", label: "法律状态", limit: 10, needTotal: true }],
    measures: [{ name: "count", label: "专利量", sortBy: "DESC" }],
    showNoDataDims: false,
  },
  chartOption: {
    chartType: ChartType.LINE,
    title: "申请人法律状态分析",
    subTitle: "",
    hideTitle: false,
    xaxisTitle: "",
    yaxisTitle: "",
    hideAxisTitle: true,
    hideLabel: true,
    hideLegend: false,
    hideToolbox: false,
  },
};
